import { useEffect } from 'react';
import { actionHandleShowProgramsAndResourcesModal } from 'store/reducers/modal';

export function useSkipSelectionStep({
  modalData,
  cohortProgram,
  setStep,
  setResourceType,
  dispatch,
}) {
  useEffect(() => {
    if (
      modalData?.mode === 'create' &&
      cohortProgram &&
      cohortProgram.isActive === false
    ) {
      setResourceType('resource');
      setStep(2);
      dispatch(
        actionHandleShowProgramsAndResourcesModal({
          mode: 'create',
          resourceType: 'resource',
        }),
      );
    }
  }, [modalData?.mode, cohortProgram, dispatch, setStep, setResourceType]);
}
